import { render, staticRenderFns } from "./MopItem.vue?vue&type=template&id=e642b164"
import script from "./MopItem.vue?vue&type=script&lang=js"
export * from "./MopItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports